import useStyles from "./styles";
import { useTheme } from "@material-ui/core/styles";
import {
  Avatar,
  Box,
  Dialog,
  DialogContent,
  Step,
  StepLabel,
  Stepper,
  useMediaQuery
} from "@material-ui/core";
import React, { ReactElement, useContext, useState } from "react";
import { Welcome } from "./Welcome";
import { Business } from "@material-ui/icons";
import StoreIcon from "@material-ui/icons/Store";
import { Article } from "@mui/icons-material";
import CheckIcon from "@material-ui/icons/Check";
import { Finish } from "./Finish";
import { Company } from "./Company";
import { StoreDetails } from "./StoreDetails";
import { Product } from "./Product";
import { UserContext } from "../../../../UserProvider";
import { Authenticated } from "../../../../models/User";
import { TenantStatus } from "../../../../models/Tenant";

export const OnBoardingDialog = () => {
  const classes = useStyles();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("xs"));
  const user = useContext(UserContext) as Authenticated;

  const getActiveStep = () => {
    switch (user.tenant.status) {
      case TenantStatus.OnBoardReady:
        return 0;
      case TenantStatus.OnBoardStep1Complete:
        return 2;
      case TenantStatus.OnBoardStep2Complete:
        return 4;
      case TenantStatus.OnBoardStep3Complete:
        return 4;
      case TenantStatus.OnBoardReviewAndConfigComplete:
        return 5;
      default:
        return 0;
    }
  };

  const [state, setState] = useState({
    activeStep: getActiveStep(),
    showOnboarding:
      user.tenant.status != undefined &&
      user.tenant.status !== TenantStatus.Active
  });

  const getIcon = (step: number, icon: ReactElement) => {
    if (state.activeStep === step) {
      return <Avatar className={classes.stepActiveColor}>{icon}</Avatar>;
    }

    if (state.activeStep > step) {
      return (
        <Avatar className={classes.stepDoneColor}>
          <CheckIcon />
        </Avatar>
      );
    }

    return <Avatar>{icon}</Avatar>;
  };

  return (
    <Dialog
      fullWidth={true}
      fullScreen={mobile}
      maxWidth={"md"}
      open={state.showOnboarding}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent className={classes.container}>
        {state.activeStep > 0 && state.activeStep < 4 && (
          <>
            <Box sx={{ width: "100%" }}>
              <Stepper activeStep={state.activeStep}>
                <Step key={1}>
                  <StepLabel icon={getIcon(1, <Business />)}>
                    Company information
                  </StepLabel>
                </Step>
                <Step key={2}>
                  <StepLabel icon={getIcon(2, <StoreIcon />)}>
                    Store details
                  </StepLabel>
                </Step>
                {/*                <Step key={3}>
                  <StepLabel icon={getIcon(3, <Article />)}>
                    Upload products
                  </StepLabel>
                </Step>*/}
              </Stepper>
            </Box>

            <div className={classes.stepContainer}>
              {state.activeStep === 1 && (
                <Company onNext={() => setState({ ...state, activeStep: 2 })} />
              )}
              {state.activeStep === 2 && (
                <StoreDetails
                  onNext={() => setState({ ...state, activeStep: 4 })}
                  onBack={() => setState({ ...state, activeStep: 1 })}
                />
              )}
              {state.activeStep === 3 && (
                <Product
                  onNext={() => setState({ ...state, activeStep: 4 })}
                  onBack={() => setState({ ...state, activeStep: 2 })}
                />
              )}
            </div>
          </>
        )}

        {state.activeStep === 0 && (
          <Welcome onClick={() => setState({ ...state, activeStep: 1 })} />
        )}

        {(state.activeStep === 4 || state.activeStep === 5) && (
          <Finish
            onClick={() => {
              //setState({ ...state, showOnboarding: false });
              window.location.reload();
            }}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
